import { EditorState } from '@tiptap/pm/state';

type SuggestionState = {
  range: { from: number; to: number };
};

export function hasSuggestionState(
  state: EditorState,
): state is EditorState & { suggestion$: SuggestionState } {
  return 'suggestion$' in state && state.suggestion$ !== undefined;
}
